import axios from 'axios';
import { apiString } from '../../../utils/constants';
import {
    IOnboarderProvider,
    IOnboardingGoalsDto,
} from '../../../Models/AdminOnboarding/OnboarderGoal.model';
import { ProgramTypeEnum } from '../../../Enum/ProgramTypeEnum';

export const getOnboardingGoals = async (
    year: number,
    month: number
): Promise<IOnboardingGoalsDto> => {
    const response = await axios.get<IOnboardingGoalsDto>(
        `${apiString}/onboarding/getonboardinggoals`,
        {
            params: {
                year,
                month,
            },
        }
    );

    return response.data;
};

export const getOnboarderProviders = async (
    roleName: string,
    includeInActiveProviders: boolean
): Promise<IOnboarderProvider[]> => {
    const response = await axios.get<IOnboarderProvider[]>(
        `${apiString}/provider/getprovidersbyrolename`,
        {
            params: {
                roleName,
                includeInActiveProviders,
            },
        }
    );

    return response.data ?? [];
};

export const updateOnboardingGoals = async (
    request: IOnboardingGoalsDto
): Promise<void> => {
    await axios.put(
        `${apiString}/onboarding/updateonboardinggoals`,
        request
    );
};

export const copyPreviousMonthGoals = async (
    sourceYear: number,
    sourceMonth: number,
    destinationYear: number,
    destinationMonth: number,
    programType?: ProgramTypeEnum
): Promise<void> => {
    await axios.post(
        `${apiString}/onboarding/copyonboardinggoals`,
        {
            SourceYear: sourceYear,
            SourceMonth: sourceMonth,
            DestinationYear: destinationYear,
            DestinationMonth: destinationMonth,
            ProgramType: programType ?? null,
        }
    );
};
